import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './GeneralButton.css'

const GeneralButton = (props: UIProperties<GeneralButtonConfig>) => {
	const [isOver, setIsOver] = useState(false);
	const [forceHighlight, setforceHighlight] = useState(false);
	if(props.parameters.onForceHighlight) {
		props.parameters.onForceHighlight((shouldForce: boolean) => {
			setforceHighlight(shouldForce);
		});
	}
	
	useEffect(() => {

	}, [isOver])

	return (
		<div style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: props.parameters.width
		}}>
			<button className="pointer" tabIndex={props.parameters.NotTabbable || props.parameters.isDisabled ? -1 : 0} aria-label={props.parameters.ariaLbl} id={props.parameters.id} style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all'
			}} onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}} onMouseOver={() => {
				if(props.parameters.highlightOnHover) {
					setIsOver(true);
				}
			}}
			aria-disabled={props.parameters.isDisabled}
			onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {

				if(props.parameters.isDisabled) {
					return;
				}

				var clickAudio = document.getElementById('button-click');

				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				

				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}}>
				<img style={{
					pointerEvents: 'none',
					...props.parameters.customImageStyle
				}} src={props.parameters.srcIdle} />
				{isOver || props.parameters.shouldLeaveOn || forceHighlight ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none',
					...props.parameters.customImageStyle
				}} src={props.parameters.srcHighlight} />) : (<div></div>)}
				{props.parameters.isDisabled ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none',
					...props.parameters.customImageStyle
				}} src={props.parameters.srcDisabled} />) : (<div></div>)}
			</button>
		</div>
	);

};

export interface GeneralButtonConfig extends BaseConfig{
	srcIdle: string;
	srcHighlight: string;
	srcDisabled?: string;
	isDisabled?: boolean;
	ariaLbl?: string;
	NotTabbable?: boolean;
	id?: string;
	top: string;
	left: string;
	width: string;
	shouldLeaveOn?: boolean;
	highlightOnHover?: boolean;
	customImageStyle?: any;
	onClicked: () => void;
	onForceHighlight?: (forceHighlight: (shouldForce: boolean) => void) => void;
}

export default GeneralButton;